<template>
  <div>
    <!-- 组织结构图 -->
    <nav-common :nav="nav"></nav-common>
    <div class="center-intro">
      <div class="center-intro-content">
        <!-- <child-detail :detail="detail"></child-detail> -->
        <div class="org-box">
          <h3>组织结构图</h3>
          <div class="detailss">
            <span>添加时间:2022-04-25</span>
            <span>来源:国家海洋标准计量中心</span>
          </div>
          <div class="org-table">
            <div class="top">
              <div class="top-item" v-for="(item,i) in detail.list1" :key='i'>
                <a @click="goDutyOnce(item)" v-html='item'></a>
              </div>
            </div>
            <div class="content">
              <a v-for="(item,i) in detail.list2" :key='i' @click="goDutyOnce(item)" v-html='item'></a>
            </div>
            <div class="foot">
              <div class="foot-left">
                <span class="line-left" :style="{'width':detail.list3&&((detail.list3.length-1)*57.3-(detail.list3.length-1)*2)+'px'}"></span>
                <ul>
                  <li v-for="(item,i) in detail.list3" :key='i'>
                    <a @click="goDutyOnce(item)" v-html='item'></a>
                  </li>
                </ul>
              </div>
              <div class="foot-right">
                <span class="line-right"></span>
                <ul>
                  <li v-for="(item,i) in listdownRight" :key='i'>
                    <a @click="goDutyOnce(item,'no')" v-html='item'></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tips">
              <span class="solid"></span>
              直接领导
              <span class="hollow"></span>
              业务监督指导
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.center-intro {
  width: 100%;
  background: #e6ecf2;
  border: 1px solid #e6ecf2;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.center-intro-content {
  width: 100%;
  background: #fff;
  color: #222;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.org-box {
  width: 889px;
  min-height: 500px;
  margin: 0 auto;
}
.org-box a {
  width: 100%;
  height: 100%;
  display: block;
  color: #ffffff;
  font-size: 18px;
}
.org-box h3 {
  font-size: 24px;
  color: #222222;
  font-weight: 700;
  text-align: center;
  padding: 45px 0 50px 0;
  letter-spacing: 2px;
}
.org-box .detailss {
  font-size: 0;
  text-align: center;
  margin-bottom: 30px;
}
.org-box .detailss > span {
  font-size: 14px;
  margin: 0 10px;
}
.org-table {
  width: 762px;
  margin: 0 auto;
}
.org-table .top {
  width: 100%;
  height: 94px;
  display: flex;
  justify-content: center;
}
.org-table .top-item {
  width: 210px;
  height: 46px;
  background: -webkit-linear-gradient(#2e65bc, #4a88e7); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#2e65bc, #4a88e7); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#2e65bc, #4a88e7); /* Firefox 3.6 - 15 */
  background: linear-gradient(#2e65bc, #4a88e7); /* 标准的语法 */
  position: relative;
  text-align: center;
  border-radius: 5px;
  line-height: 46px;
  margin: 0 13px;
  cursor: pointer;
}
.org-table .top-item::before {
  content: "";
  height: 50px;
  width: 2px;
  background: #3068bf;
  position: absolute;
  left: 105px;
  bottom: -50px;
  display: block;
}
.org-table .top-item:last-of-type {
  width: 208px;
  height: 44px;
  background: #ffffff;
  position: relative;
  text-align: center;
  border-radius: 5px;
  line-height: 46px;
  border: 1px solid #3068bf;
}
.org-table .top-item:last-of-type a {
  color: #3068bf;
}
.org-table .top-item:last-of-type::before {
  content: "";
  height: 50px;
  width: 2px;
  background: #3068bf;
  position: absolute;
  left: 105px;
  bottom: -50px;
  display: block;
  margin: 0 13px;
}
.org-table .content {
  width: 100%;
  height: 46px;
  background: -webkit-linear-gradient(#2e65bc, #4a88e7); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#2e65bc, #4a88e7); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#2e65bc, #4a88e7); /* Firefox 3.6 - 15 */
  background: linear-gradient(#2e65bc, #4a88e7); /* 标准的语法 */
  text-align: center;
  line-height: 46px;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
}
.org-table .foot {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 34px;
}
.foot-left,
.foot-right {
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.foot-left ul,
.foot-right ul {
  display: flex;
  justify-content: flex-start;
}
.foot-left ul li {
  width: 46px;
  height: 350px;
  background: #4a88e7;
  border-radius: 5px;
  margin-right: 9px;
  margin-top: 24px;
  position: relative;
}
.foot-left ul li::before {
  content: "";
  width: 2px;
  height: 24px;
  display: block;
  position: absolute;
  left: 22px;
  top: -24px;
  background: #4a88e7;
}
.foot-left ul li a,
.foot-right ul li a {
  text-align: center;
  line-height: 16px;
  letter-spacing: 10px;
  box-sizing: border-box;
  padding: 30px 15px 0 15px;
  line-height: 18px;
}
.foot-left ul li a{
  cursor: pointer;
}
.line-left {
  position: absolute;
  height: 2px;
  background: #4a88e7;
  display: block;
  left: 22px;
  top: -2px;
}
.line-left::before {
  content: "";
  width: 2px;
  height: 34px;
  background: #4a88e7;
  display: block;
  position: absolute;
  left: 275px;
  top: -34px;
}
.foot-right ul li {
  width: 44px;
  height: 346px;
  background: #fff;
  border: 1px solid #3068bf;
  border-radius: 5px;
  margin-right: 9px;
  margin-top: 24px;
  position: relative;
}
.foot-right ul li:last-child {
  margin-right: 0;
}
.foot-right ul li a {
  color: #3068bf;
}
.foot-right ul li::before {
  content: "";
  border: 1px dashed #3068bf;
  height: 24px;
  display: block;
  position: absolute;
  left: 22px;
  top: -26px;
  background: #4a88e7;
}
.foot-right .line-right {
  width: 110px;
  border: 1px dashed #4a88e7;
  display: block;
  position: absolute;
  left: 23px;
  top: -2px;
}
.foot-right .line-right::before {
  height: 34px;
  border: 1px dashed #4a88e7;
  content: "";
  display: block;
  position: absolute;
  left: 54px;
  top: -34px;
}
.tips {
  margin-top: 34px;
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  color: #1052b8;
  line-height: 24px;
}
.solid {
  width: 16px;
  height: 16px;
  background: #1052b8;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  margin: 4px 10px 0 0;
}
.hollow {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 1px solid #1052b8;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  margin: 4px 10px 0 20px;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import childDetail from "./childDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "中心概况",
        firstrouteName: "centerIntro",
        secondtitle: "组织结构图",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      detail: {},
      listdownRight: []
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      userApi.department().then(res => {
        this.listdownRight = res.data.list3.splice(-3)
        this.detail = res.data;
      });
    },
    goDutyOnce(name,tk){
      if(tk==='no'){
        return;
      }
      if(name==='自然资源部'){
        location.href = 'http://www.mnr.gov.cn/'
      }else if(name==='国家市场监督管理总局'){
        location.href = 'http://www.samr.gov.cn/'
      }else{
        this.$router.push({
          path: '/org/duty',
          query:{
            name: window.encodeURI(name)
          }
        })
      }
    }
  },
  components: {
    navCommon,
    childDetail
  }
};
</script>





// WEBPACK FOOTER //
// src/components/views/Organization/Children/organMap.vue